<!-- <section class="FirstScroll_Section">
    <div class="container nopad SectionContainer">
        <div class="col-md-12 col-sm-12 col-xs-12 nopad">
            <div class="col-md-12 col-sm-12 col-xs-12 nopad" style="margin-top : 0 !important;">

                <ul class="nav nav-tabs MenuTabList">
                    <li class="nav-item menuTabItem">
                        <a class="nav-link active navLink" data-toggle="tab" href="#Instructions">Instructions</a>
                    </li>
                    <li class="nav-item menuTabItem">
                        <a class="nav-link navLink" data-toggle="tab" href="#UserManual">User Manual</a>
                    </li>
                    <li class="nav-item menuTabItem">
                        <a class="nav-link navLink" data-toggle="tab" href="#SampleFormats">Sample Formats</a>
                    </li>
                    <li class="nav-item menuTabItem">
                        <a class="nav-link navLink" data-toggle="tab" href="#Reports">Reports</a>
                    </li>
                </ul>
                <div class="clearfix"></div>

                <div class="tab-content"> -->
                    <!-- <div id="Instructions" class="container tab-pane active nopad tabContent_Container">
                        <div class="col-md-12 col-sm-12 col-xs-12 nopad">
                            <ul style="list-style-type: none; padding: 0;">
                                <li style="border-bottom: 1px solid #000;height: 50px;">
                                    <span style="line-height: 50px;color: #0d4f8b;font-weight: 500;color: #0d4f8b;font-weight: 500;">The standard Lorem Ipsum passage, used since the
                                        1500s</span>
                                    <a href="/assets/data/user_manual.pdf" download
                                        style="float: right;margin-left: 20px;width: 120px;background-color: #eea412;color: #fff;border-radius: 20px;height: 30px;border: 2px #fff solid;box-shadow: 4px 4px 4px #0000007a;text-align: center;line-height: 26px;text-decoration: none;margin-top: 10px;">Download</a>
                                </li>
                                <li style="border-bottom: 1px solid #000;height: 50px;">
                                    <span style="line-height: 50px;color: #0d4f8b;font-weight: 500;">The standard Lorem Ipsum passage, used since the
                                        1500s</span>
                                    <a href="/assets/data/user_manual.pdf" download
                                        style="float: right;margin-left: 20px;width: 120px;background-color: #eea412;color: #fff;border-radius: 20px;height: 30px;border: 2px #fff solid;box-shadow: 4px 4px 4px #0000007a;text-align: center;line-height: 26px;text-decoration: none;margin-top: 10px;">Download</a>
                                </li>
                                <li style="border-bottom: 1px solid #000;height: 50px;">
                                    <span style="line-height: 50px;color: #0d4f8b;font-weight: 500;">The standard Lorem Ipsum passage, used since the
                                        1500s</span>
                                    <a href="/assets/data/user_manual.pdf" download
                                        style="float: right;margin-left: 20px;width: 120px;background-color: #eea412;color: #fff;border-radius: 20px;height: 30px;border: 2px #fff solid;box-shadow: 4px 4px 4px #0000007a;text-align: center;line-height: 26px;text-decoration: none;margin-top: 10px;">Download</a>
                                </li>
                                <li style="border-bottom: 1px solid #000;height: 50px;">
                                    <span style="line-height: 50px;color: #0d4f8b;font-weight: 500;">The standard Lorem Ipsum passage, used since the
                                        1500s</span>
                                    <a href="/assets/data/user_manual.pdf" download
                                        style="float: right;margin-left: 20px;width: 120px;background-color: #eea412;color: #fff;border-radius: 20px;height: 30px;border: 2px #fff solid;box-shadow: 4px 4px 4px #0000007a;text-align: center;line-height: 26px;text-decoration: none;margin-top: 10px;">Download</a>
                                </li>
                                <li style="border-bottom: 1px solid #000;height: 50px;">
                                    <span style="line-height: 50px;color: #0d4f8b;font-weight: 500;">The standard Lorem Ipsum passage, used since the
                                        1500s</span>
                                    <a href="/assets/data/user_manual.pdf" download
                                        style="float: right;margin-left: 20px;width: 120px;background-color: #eea412;color: #fff;border-radius: 20px;height: 30px;border: 2px #fff solid;box-shadow: 4px 4px 4px #0000007a;text-align: center;line-height: 26px;text-decoration: none;margin-top: 10px;">Download</a>
                                </li>
                                <li style="border-bottom: 1px solid #000;height: 50px;">
                                    <span style="line-height: 50px;color: #0d4f8b;font-weight: 500;">The standard Lorem Ipsum passage, used since the
                                        1500s</span>
                                    <a href="/assets/data/user_manual.pdf" download
                                        style="float: right;margin-left: 20px;width: 120px;background-color: #eea412;color: #fff;border-radius: 20px;height: 30px;border: 2px #fff solid;box-shadow: 4px 4px 4px #0000007a;text-align: center;line-height: 26px;text-decoration: none;margin-top: 10px;">Download</a>
                                </li>
                                <li style="border-bottom: 1px solid #000;height: 50px;">
                                    <span style="line-height: 50px;color: #0d4f8b;font-weight: 500;">The standard Lorem Ipsum passage, used since the
                                        1500s</span>
                                    <a href="/assets/data/user_manual.pdf" download
                                        style="float: right;margin-left: 20px;width: 120px;background-color: #eea412;color: #fff;border-radius: 20px;height: 30px;border: 2px #fff solid;box-shadow: 4px 4px 4px #0000007a;text-align: center;line-height: 26px;text-decoration: none;margin-top: 10px;">Download</a>
                                </li>
                            </ul>
                        </div>
                        <div class="clearfix"></div>
                    </div> -->


                    <!-- <div id="Instructions" class="container bannerSection boxShadow tab-pane active" style="padding:30px;">
                        <div class="col-md-12 col-sm-12 col-xs-12 nopad">
                          <table>
                            <thead>
                              <tr>
                                <th scope="col">S.No.</th>
                                <th scope="col">Title</th>
                                <th scope="col">Download</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td scope="row" data-label="sno" class="downlSerial">1</td>
                                <td data-label="subject" class="text-center downlTitle">The standard Lorem Ipsum passage, used since the 1500s</td>
                                <td data-label="file" class="text-center downlFile">
                                  <div>
                                    <a href="/assets/data/user_manual.pdf" download>
                                        <mat-icon matTooltip="Download Now"><i class="fa fa-download"></i></mat-icon>
                                    </a>
                                  </div>
                                </td>
                              </tr>

                              <tr>
                                <td scope="row" data-label="sno" class="downlSerial">2</td>
                                <td data-label="subject" class="text-center downlTitle">The standard Lorem Ipsum passage, used since the 1500s</td>
                                <td data-label="file" class="text-center downlFile">
                                  <div>
                                    <a href="/assets/data/user_manual.pdf" download>
                                        <mat-icon matTooltip="Download Now"><i class="fa fa-download"></i></mat-icon>
                                    </a>
                                  </div>
                                </td>
                              </tr>

                              <tr>
                                <td scope="row" data-label="sno" class="downlSerial">3</td>
                                <td data-label="subject" class="text-center downlTitle">The standard Lorem Ipsum passage, used since the 1500s</td>
                                <td data-label="file" class="text-center downlFile">
                                  <div>
                                    <a href="/assets/data/user_manual.pdf" download>
                                        <mat-icon matTooltip="Download Now"><i class="fa fa-download"></i></mat-icon>
                                    </a>
                                  </div>
                                </td>
                              </tr>

                              <tr>
                                <td scope="row" data-label="sno" class="downlSerial">4</td>
                                <td data-label="subject" class="text-center downlTitle">The standard Lorem Ipsum passage, used since the 1500s</td>
                                <td data-label="file" class="text-center downlFile">
                                  <div>
                                    <a href="/assets/data/user_manual.pdf" download>
                                        <mat-icon matTooltip="Download Now"><i class="fa fa-download"></i></mat-icon>
                                    </a>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                            
                          </table>
                         </div>
                          <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons>
                        </mat-paginator>
                        <div class="clearfix"></div>
                      </div>



                    <div id="UserManual" class="container tab-pane fade tabContent_Container">
                        <div class="col-md-12 col-sm-12 col-xs-12 nopad">
                            <div class="col-md-3 col-sm-3 col-xs-12 floatLeft">
                                <a href="/assets/data/user_manual.pdf" download>
                                    <div class="DownloadItem">
                                        <img src="/assets/images/dummy.jpg" class="DownloadImage" />
                                        <div class="CaptionContainer">
                                            <h3>Student</h3>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div class="col-md-3 col-sm-3 col-xs-12 floatLeft">
                                <a href="/assets/data/user_manual.pdf" download>
                                    <div class="DownloadItem">
                                        <img src="/assets/images/dummy.jpg" class="DownloadImage" />
                                        <div class="CaptionContainer">
                                            <h3>Faculty</h3>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div class="col-md-3 col-sm-3 col-xs-12 floatLeft">
                                <a href="/assets/data/user_manual.pdf" download>
                                    <div class="DownloadItem">
                                        <img src="/assets/images/dummy.jpg" class="DownloadImage" />
                                        <div class="CaptionContainer">
                                            <h3>Institutions</h3>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                    <div id="SampleFormats" class="container tab-pane fade tabContent_Container">
                        <p>Sample Formats</p>
                        <div class="clearfix"></div>
                    </div>
                    <div id="Reports" class="container tab-pane fade tabContent_Container">
                        <p>Reports</p>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>

        </div>
    </div>
</section>

<div class="clearfix"></div> -->



<div class="row">
    <div class="col-md-12 col-sm-12 col-xs-12 nopad">
        <h2 class="SectionHeading">Downloads</h2>
    </div>
  </div>
  
  <div id="listView" class="container bannerSection boxShadow tab-pane active" style="padding:30px;">
    <div class="col-md-12 col-sm-12 col-xs-12 nopad">
  
    <div class="clearfix"></div>
  
  
    <mat-table #matTable class="dataTable" [dataSource]="dataSource" matSort #sort="matSort">
      <ng-container matColumnDef="sno">
          <mat-header-cell *matHeaderCellDef> S No. </mat-header-cell>
          <mat-cell *matCellDef="let i=index;"> {{i+1}} </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="subject">
          <mat-header-cell *matHeaderCellDef> Subject </mat-header-cell>
          <mat-cell *matCellDef="let element">{{element?.title}} </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
          <mat-cell *matCellDef="let element">{{element?.downloads_date | date:'dd/MM/y'}} </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="file">
          <mat-header-cell *matHeaderCellDef> File </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div *ngIf="element.file">
            <a target="_blank" href="{{baseBackUrl}}/downloadsHomepage?id={{element.id}}">
              <mat-icon matTooltip="{{element.file}}"><i class="fa fa-download"></i></mat-icon>
            </a>
          </div>
            <div *ngIf="!element.file">
              <p>--</p>
          </div>
          </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="url">
        <mat-header-cell *matHeaderCellDef> URL </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div *ngIf="element.url">
          <a target="_blank" (click)="routeByUrl(element.url)">
            <mat-icon matTooltip="{{element.url}}" class="url">remove_red_eye</mat-icon>
          </a>
        </div>
          <div *ngIf="!element.url">
            <p>--</p>
        </div>
        </mat-cell>
    </ng-container>
  
  
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  
      <mat-row *matNoDataRow>
          <mat-cell colspan="4">No data matching the filter</mat-cell>
      </mat-row>
  
    </mat-table>
    <div *ngIf="!downloads">
        <p class="text-center" style="padding-top: 35px; font-size: 18px; color: red;">No Downloads</p>
    </div>
   </div>
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons>
  </mat-paginator>
  </div>